import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import WarningIcon from "@material-ui/icons/Warning";

const useStyles = makeStyles(() => ({
  dialogPaper: {
    maxWidth: 400,
    minWidth: 350,
  },
  iconContainer: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: 16,
  },
  icon: {
    color: "#F04438",
    fontSize: 48,
  },
  title: {
    textAlign: "center",
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 8,
  },
  description: {
    textAlign: "center",
    color: "#667085",
    fontSize: 14,
    lineHeight: 1.5,
  },
  actionButton: {
    backgroundColor: "#F04438",
    color: "white",
    fontWeight: 500,
    textTransform: "none",
    "&:hover": {
      backgroundColor: "#D92D20",
    },
  },
}));

export default function SessionExpiredDialogComponent({ open, onClose }) {
  const classes = useStyles();

  const handleOkClick = () => {
    // Clear local storage to ensure fresh state
    localStorage.clear();

    // Clear any axios authorization headers
    delete window.axios?.defaults?.headers?.common?.Authorization;

    // Force a page refresh and redirect to login
    window.location.href = "/login";
  };

  // Prevent closing the dialog in any other way except clicking OK
  const handleDialogClose = (event, reason) => {
    // Only allow programmatic closing or OK button click
    if (reason === "backdropClick" || reason === "escapeKeyDown") {
      return;
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleDialogClose}
      classes={{
        paper: classes.dialogPaper,
      }}
      maxWidth="sm"
    >
      <DialogContent>
        <Box className={classes.iconContainer}>
          <WarningIcon className={classes.icon} />
        </Box>

        <Typography className={classes.title}>Session Expired</Typography>

        <Typography className={classes.description}>
          Your session has expired. Please log in again to continue.
        </Typography>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleOkClick}
          className={classes.actionButton}
          variant="contained"
          fullWidth
          size="large"
        >
          OK
        </Button>
      </DialogActions>
    </Dialog>
  );
}
